import React from 'react';
import styled from 'styled-components';
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Dialog from '@material-ui/core/Dialog';

const StyleCss = styled.div`
    .popup-container .popup-content{
        height: calc(100% - 4rem);
        overflow: auto;
        width:calc(100% - 4rem) ;
        padding: 2rem;
        .message{
            display: flex;
            margin: 0.7rem 0.5rem;
            color: var(--text-2);
            font-size: var(--fs-basket-buy-err-text);
            font-weight: 300;
            .icon{
                margin-left: 0.5rem;
                color: var(--secondry-1);
            }
        }
        .btns {
            display: flex;
            .confirm , .close{
                margin: 0.5rem;
                cursor: pointer;
                width: calc(50% - 1rem);
                border: none;
                outline: none;
                border-radius: 0.5rem;
                background-color: var(--primary-1);
                color: var(--text-3);
                padding: 0.5rem 0 0.7rem;
                text-align: center;
                display: flex;
                justify-content: center;
                font-size: var(--fs-basket-buy-err-button) ;
                font-weight: 500;
                transition: all 0.2s ease-in-out;
                opacity: 0.8;
                :hover{
                    opacity: 1;
                }
            }
            .close {
                background-color: var(--text-4);
                color: var(--text-3);
            }
        }
        
    }
    .order{
        .popup-content .btns{ 
            .confirm{
            background-color: var(--secondry-1) ;
            }
            .blue{
                background-color: var(--primary-1);
            }
        }

    }
    @media screen and (max-width:600px){
        .popup-container{
            width: 100%;
        }
    }

`;


class FullsizeErrors extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            show: this.props.show,
            sending: false,
            response: 'none',
        };
    }
    getSnapshotBeforeUpdate(prevProps, prevState){
        if (prevProps.show !== this.props.show){
            return true;
        } else {
            return false;
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if (snapshot){
            this.setState({
                show: this.props.show,
            });
        }
    }

    Make = () => {
        return (
            <StyleCss>
                <div className={"popup-container " + this.props.classname}>
                    <div className="popup-content">
                        <div className="message">
                            {!this.props.basket ? '' : <FontAwesomeIcon icon={faTrash} className='icon'/> }
                            {this.props.message}
                        </div>
                        <div className="btns ">
                            <div className={'confirm ' + this.props.return} onClick={this.props.confirm}>
                                 {this.props.confirmText ? this.props.confirmText : "بله حذف شود"}
                            </div>
                            <div className='close' onClick={this.props.close}>
                                {this.props.cancelText ?this.props.cancelText :"لغو"}
                            </div>
                        </div>
                    </div>
                </div>
            </StyleCss>
            );
    }

    render() {
        if(this.state.show){
            return (
                <Dialog
                    fullWidth={true}
                    maxWidth={'sm'}
                    open={this.props.show}
                    onClose={this.props.close}
                    style={{backgroundColor: 'rgba(0,0,0,0.5)'}}
                >
                    {this.Make()}
                </Dialog>
            )
        } else {
            return null;
        }
    }
}

export default FullsizeErrors;